import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Group } from "@interfaces/group.interface";
import { User } from "@interfaces/user.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { GroupService } from "@services/group.service";
import { MenuItemService } from "@services/menuItem.service";
import { UserService } from "@services/user.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "groups-id",
	styleUrls: ["groups-id.css"],
	templateUrl: "groups-id.html"
})
export class GroupsIdAdminComponent {
	dropDownPeople: UserProfile[] = [];
	groupUsers: User[] = []
	headerPrimaryButtons: AdminHeaderButton[] = [];
	isSuperAdmin = false;
	item: Group = new Group();
	itemId = "";
	itemType = "Group";
	menuItems: any = []
	people: UserProfile[] = [];
	popupAddButtonOptions: any;
	popupAddUserToGroup: any = { userId: 0 };
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupTitle = "";
	popupVisible = false;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;

	constructor(private appSettingsService: AppSettingsService, private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: GroupService, private menuItemService: MenuItemService, private userService: UserService, private userProfileService: UserProfileService) {
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");
		this.buildButtons();
		this.getPeople();
		this.route.params
			.subscribe((params) => {
				this.getItem(params.id);
			});

		this.removeUserFromGroup = this.removeUserFromGroup.bind(this);
	}
	
	addUserToGroup() {
		this.userService.toggleGroup(this.popupAddUserToGroup.userId, this.item.id)
			.subscribe(
				() => {
					this.popupVisible = false;
					this.getGroupUsers();
				},
				(err: any) => console.log(err)
			);
	}

	addUserToGroupPopup() {
		this.dropDownPeople = [];
		this.people.forEach((person) => {
			const userInGroup = this.groupUsers.filter(gu => gu.id === person.userId);

			if (userInGroup.length === 0) {
				this.dropDownPeople.push(person);
			}
		});
		this.popupAddUserToGroup = { userId: 0 };
		this.popupTitle = "Add User to Group";
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addUserToGroup(), text: "Add User" };
	}

	boolYesNo(cellInfo: any) {
		if(cellInfo.value === true)
		{
			return "YES";
		}
		else
		{
			return "NO";
		}
	}

	buildButtons() {
		this.headerPrimaryButtons = [
			{ method: "updateItem", text: "Save Notes" },
			{ method: "close", text: "Close" }
		];
		if (this.isSuperAdmin) {
			this.headerPrimaryButtons.unshift({ method: "addUserToGroupPopup", text: "Add User" });
		}
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePopup() {
		this.popupVisible = false;
	}
	
	getGroupUsers() {
		this.userService.getUsersInGroup(this.item.id)
			.subscribe(
				(res: any) =>  {
					this.groupUsers = res.response;
					this.groupUsers.sort((a: any, b: any) => (a.firstName + " " + a.lastName).localeCompare((b.firstName + " " + b.lastName)));
				},
				(err) => console.log(err)
			);
	}
	
	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getGroupUsers();
					this.getMenuItems();
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}
	
	getMenuItems() {
		this.menuItemService.getByGroupId(this.item.id)
			.subscribe(
				(res: any) =>  {
					this.menuItems = res.response;
				},
				(err) => console.log(err)
			);
	}
	
	getPeople() {
		this.userProfileService.getAll()
			.subscribe(
				(res: any) =>  {
					this.people = res.response.items;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	removeUserFromGroup(e: any) {
		if (confirm("Are you sure you wish to remove this user from the group? This change will be refleacted when they next log in.") === false) {
			return;
		}

		this.userService.toggleGroup(e.row.data.id, this.item.id)
			.subscribe(
				() =>  {
					this.getGroupUsers();
				},
				(err) => console.log(err)
			);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}